import React from 'react';

import styled from '@emotion/styled';
import { Card } from '@material-ui/core';

export const CardWrapper = styled.div`
  margin-top: 1.5rem;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  border-radius: 8px !important;
  padding: 12px;
  background: white;
`;

export const CardHeaderWrapper = styled.div`
  background: white;
  border-radius: 0px;
  padding: 8px;
  border-bottom: 1px solid ${(props) => props.theme.colors.neutral.CFD7DF};
`;
function CardHeader({ headerContent }) {
  if (!headerContent) return null;
  return <CardHeaderWrapper>{headerContent}</CardHeaderWrapper>;
}

function FeedCard({ className, headerComp = null, children }) {
  return (
    <CardWrapper>
      <Card className={className || ''} elevation={0} style={{ overflow: 'visible' }}>
        {headerComp && <CardHeader headerContent={headerComp} />}
        {children}
      </Card>
    </CardWrapper>
  );
}

export default FeedCard;
